import { render, staticRenderFns } from "./PurchaseComponent.vue?vue&type=template&id=4cf6f16e&"
import script from "./PurchaseComponent.vue?vue&type=script&lang=js&"
export * from "./PurchaseComponent.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports